import React from "react";
import { InfoBoxTitle, InfoBoxWrapper } from "../Styled";
import { SubSection, SubSectionTitle } from "./Styled";
import DueDate from "./DueDate";
import { ProductOrder } from "../../../../data/entities";

interface PriorityProps {
    productOrder: ProductOrder;
    mergeProductOrder: Function;
}

const Priority = ({ productOrder, mergeProductOrder }: PriorityProps) => {
    return (
        <InfoBoxWrapper>
            <InfoBoxTitle>Thời hạn đơn hàng</InfoBoxTitle>
            <SubSection>
                <SubSectionTitle>
                    <div>Ngày đến hạn</div>
                    <div style={{ color: "red" }}>*</div>
                </SubSectionTitle>
                <DueDate
                    dueDate={productOrder.due_date}
                    setDueDate={(value: string) =>
                        mergeProductOrder({ due_date: value })
                    }
                />
            </SubSection>
        </InfoBoxWrapper>
    );
};

export default Priority;
